<style lang="scss">
@import 'resources/sass/v1/abstracts/_variables';

.navigation-overlay {
    position: fixed;
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100 - 80px); //vh fix from app.js
    z-index: 9999999;
    top: 80px;
    left: 0;
    opacity: 0;
    pointer-events: none;
    @apply transition-opacity flex md:top-[103px] lg:top-[167px];

    @media screen and (max-width: $screen-sm-end) {
        overflow: scroll;
    }

    &.active {
        opacity: 1;
        pointer-events: all;
    }
}

body.resizing {
    .navigation-overlay {
        transition: none !important;
    }
}
</style>

<template>
    <div class="navigation-overlay bg-white" :class="{ active: $root.navigationIsVisble }">
        <div class="navigation-overlay-inner flex-1 lg:flex flex-col justify-center">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {};
</script>
